import React from 'react'
import { Route, Routes } from 'react-router'
import CreateService from '../componets/Dashboard/Create/SelectService'
import GameSelection from '../componets/Dashboard/Create/GameServer/GameSelection'
import LocationSelection from '../componets/Dashboard/Create/GameServer/LocationSelection'
import PacakageSelection from '../componets/Dashboard/Create/GameServer/PackageSelection'

const HostingOrderRouter = () => {
  return (
    <Routes>
        <Route path=''>
            <Route path='/' element={<CreateService />} />
            <Route path='/:cat' element={<GameSelection />} />
            <Route path='/:cat/:gamename' element={<LocationSelection />} />
            <Route path='/:cat/:gamename/:location' element={<PacakageSelection />} />
        </Route>
    </Routes>
  )
}

export default HostingOrderRouter